<template>
    <div class="l-row m-card m-card--dark">
        <div class="l-row__column">
            <div class="l-row m-card__container">
                <div
                    v-if="title"
                    class="l-row__column"
                >
                    <div class="m-card__header">
                        <a-icon
                            icon="NoteBig"
                            class="m-card__headerIcon"
                        />
                        <h2 class="a-title m-card__title">{{ title }}</h2>
                    </div>
                    <p class="a-text" v-html="content"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: 'Notatka'
        },
        content: {
            type: String,
            default: ''
        }
    }
}
</script>